export const validateImageFile = (
  file: File,
  maxSizeMB = 10,
  allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"]
): string | null => {
  if (!allowedTypes.includes(file.type)) {
    return "Invalid file type. Only PNG, JPG, and JPEG are allowed.";
  }

  const maxSizeInBytes = maxSizeMB * 1024 * 1024;
  if (file.size > maxSizeInBytes) {
    return `Image size exceeds ${maxSizeMB}MB limit.`;
  }

  return null;
};
